import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/home/prev-icon.png'
import _imports_1 from '@/assets/images/beian-icon.png'
import _imports_2 from '@/assets/images/code1.png'
import _imports_3 from '@/assets/images/code2.png'


const _hoisted_1 = { class: "bottom-box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNavigation',
  setup(__props) {

const router = useRouter()
const showListIndex = ref(-1)
const store = useStore()
const routerList: any = [
  {
    title: '产品服务',
    value: [
      {
        name: '数智产品',
        path: '/product_service',
        titleIndex: 1,
        pageTitle: ['产品服务', '数智产品']
      },
      {
        name: '渠道拓展',
        path: '/channel_expansion',
        titleIndex: 1,
        pageTitle: ['产品服务', '渠道拓展']
      }
    ]
  },
  {
    title: '解决方案',
    value: [
      {
        name: '文娱解决方案',
        path: '/solution',
        index: 0,
        titleIndex: 2,
        pageTitle: ['解决方案', '文娱解决方案']
      },
      {
        name: '工业解决方案',
        path: '/solution',
        index: 1,
        titleIndex: 2,
        pageTitle: ['解决方案', '工业解决方案']
      },
      {
        name: '教育解决方案',
        path: '/solution',
        index: 2,
        titleIndex: 2,
        pageTitle: ['解决方案', '教育解决方案']
      },
      {
        name: '医疗解决方案',
        path: '/solution',
        index: 3,
        titleIndex: 2,
        pageTitle: ['解决方案', '医疗解决方案']
      },
      {
        name: '军警部队解决方案',
        path: '/solution',
        index: 4,
        titleIndex: 2,
        pageTitle: ['解决方案', '军警部队解决方案']
      }
    ]
  },
  {
    title: '关于我们',
    value: [
      {
        name: '公司介绍',
        path: '/about_us_view',
        titleIndex: 5,
        pageTitle: ['关于我们', '公司介绍']
      },
      {
        name: '新闻动态',
        path: '/about_us',
        titleIndex: 5,
        pageTitle: ['关于我们', '新闻动态']
      },
      {
        name: '加入我们',
        path: '/about_detail',
        titleIndex: 5,
        pageTitle: ['关于我们', '加入我们']
      }
    ]
  },
  {
    title: '合作咨询',
    value: [
      {
        name: '何洋 13225532650',
        path: '',
      },
    ]
  },
]

const changeRouter = (e: any, titleIndex: number) => {
  if (!e.path) return
  if (e.path == '/solution') {
    router.push(`${e.path}?type=${e.index}&pathName=${e.pageTitle[0]},${e.pageTitle[1]}`)
    store.state.programmeIndex = e.index
  } else {
    router.push(`${e.path}?pathName=${e.pageTitle[0]},${e.pageTitle[1]}`);
  }
  store.state.titleIndex = titleIndex;
  store.state.pageTitle = [...e.pageTitle]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routerList, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: _normalizeClass(["navigation-list", showListIndex.value == index ? 'active' : ''])
        }, [
          _createElementVNode("div", {
            class: "title",
            onClick: ($event: any) => (showListIndex.value == index ? showListIndex.value = -1 : showListIndex.value = index)
          }, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1),
            _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1))
          ], 8, _hoisted_2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (e, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: i,
              onClick: ($event: any) => (changeRouter(e, e.titleIndex))
            }, _toDisplayString(e.name), 9, _hoisted_3)), [
              [_vShow, showListIndex.value == index]
            ])
          }), 128))
        ], 2)
      }), 64))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"bottom-box-text\" data-v-2ef217ad><div data-v-2ef217ad><div data-v-2ef217ad>上海市徐汇区钦州北路1001号光启园7号楼6层</div><div data-v-2ef217ad>沪ICP备2023012463号—1</div><div data-v-2ef217ad>版权所有 ©️ 2023上海凝丰智能科技有限公司</div><div data-v-2ef217ad><img src=\"" + _imports_1 + "\" data-v-2ef217ad><span data-v-2ef217ad>沪公网安备 31010402010108号</span></div></div><div data-v-2ef217ad><div data-v-2ef217ad><img src=\"" + _imports_2 + "\" data-v-2ef217ad><div data-v-2ef217ad>公众号</div></div><div data-v-2ef217ad><img src=\"" + _imports_3 + "\" data-v-2ef217ad><div data-v-2ef217ad>视频号</div></div></div></div>", 1))
  ]))
}
}

})